import { TriangleAlert } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export interface ChapterValidationMessage {
  id: string
  text: string
  /** DOM id `smoothScrollIntoView`/`focus()` target on click. */
  targetId: string
}

/**
 * document-editor.md's `FormChapterValidationAlert` — one consolidated
 * destructive alert per chapter, rendered above the chapter's first
 * `FormCard`, replacing a separate alert beneath each related field row.
 * Every message is a clickable, underlined list item that smooth-scrolls to
 * and focuses its own `targetId`.
 */
export function FormChapterValidationAlert({
  messages,
}: {
  messages: ChapterValidationMessage[]
}) {
  if (messages.length === 0) return null

  function handleClick(targetId: string) {
    const target = document.getElementById(targetId)
    if (!target) return
    target.scrollIntoView({ behavior: "smooth", block: "center" })
    target.focus()
  }

  return (
    <Alert variant="destructive">
      <TriangleAlert aria-hidden />
      <AlertTitle>Перевірте дані на цій вкладці</AlertTitle>
      <AlertDescription>
        <ul className="list-disc space-y-0.5 pl-4">
          {messages.map((message) => (
            <li key={message.id}>
              <button
                className="text-left underline underline-offset-2"
                onClick={() => handleClick(message.targetId)}
                type="button"
              >
                {message.text}
              </button>
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  )
}
